interface ApplePodcastsIconProps {
  className?: string;
}

export function ApplePodcastsIcon({ className }: ApplePodcastsIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="#872EC4"
      aria-hidden
    >
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 4.5a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5zm0 15.75c-3.107 0-5.859-1.49-7.618-3.802a.624.624 0 0 1 .096-.87C5.74 14.554 8.67 13.5 12 13.5s6.26 1.054 7.522 2.078a.624.624 0 0 1 .096.87C17.859 18.76 15.107 20.25 12 20.25z" />
    </svg>
  );
}
